import { render, staticRenderFns } from "./StatisticsOrders.vue?vue&type=template&id=5cc53fe9&scoped=true"
import script from "./StatisticsOrders.vue?vue&type=script&lang=js"
export * from "./StatisticsOrders.vue?vue&type=script&lang=js"
import style0 from "./StatisticsOrders.vue?vue&type=style&index=0&id=5cc53fe9&prod&lang=css"
import style1 from "./StatisticsOrders.vue?vue&type=style&index=1&id=5cc53fe9&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc53fe9",
  null
  
)

export default component.exports